/**
 * key 和 value 里面的 path 属性保持一致, 都是整体路由
 * value 的一些属性备注
 *     name 显示在头部菜单的内容
 *     title 显示在具体内容的标题, 大部分情况下和 name 相同, 可能存在和 name 不同
 *     hidden 是否隐藏此项, 为 true 表示隐藏, 默认 false 或 undefined
 *     routeType 路由类型, 在工具菜单内属于哪个类型 1: 卡首屏系列 2: 手淘卡屏
 *     invokeName 请求日志需要的参数
 *     priceName 请求工具价格需要的参数
 *     freeForMembers true 表示菜单展示会员免费 默认 false 或 undefined
 * 注意: menus 里面的卡首屏和手淘卡屏区分是通过 routeType, 接口里面卡首屏和手淘卡屏区分是通过 invokeName
 */
const infoData = {
    '/first-flow-pdd/said-ok': {
        name: '大家都说好',
        title: '大家都说好',
        path: '/first-flow-pdd/said-ok',
        desc: '通过拼多多推荐卡屏后会跳转到【大家都说好】页面，商品卡在首屏，找到商品直接下单，能极大的提升权重',
        hidden: false, // 是否隐藏, 默认 false
        routeType: '1', // 路由类型 1: 卡首屏系列
        freeForMembers: false,
        priceName: "pdddjdsh",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "pdddjdsh", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    },
    "/first-flow-pdd/first-flow": {
        name: '搜索卡首屏',
        title: '搜索卡首屏',
        path: '/first-flow-pdd/first-flow',
        desc: '通过拼多多搜索卡首屏二维码下单，提升该关键词搜索权重',
        hidden: false, // 是否隐藏, 默认 false
        routeType: '1', // 路由类型 1: 卡首屏系列
        freeForMembers: false,
        priceName: "pddssksp",
        logType: "qrcode", // log 是生成记录, qrcode 是二维码生成记录
        logName: "pddssksp", // 之前日志是 invokeName, 后期改版, invokeName 专门用来获取 type, 日志由 logType 和 logName 处理
    }
}

export {
    infoData,
}
